import {createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { UpdateOnboardingStepsRequest } from '../requests/update.onboarding.steps.request';
import { OnboardingSteps } from '../models/onboarding.steps';
import { Status } from '../redux/redux.status';
import { State } from '../redux/redux.state';
import client from '../clients/client';

type OnboardingState = State<OnboardingSteps[]> & {
	updateStatus: Status;
}

const initialState: OnboardingState = {
	data: [],
	status: 'idle',
	updateStatus: 'idle'
}

const url = 'onboarding';

export const getOnboardingSteps = createAsyncThunk<OnboardingSteps[], string>('getOnboardingSteps', async(shopId: string, {rejectWithValue}) => {
	try {
		const { data } = await client.get(`${url}/${shopId}`)
		return data;
	}catch (err: any) {
      const { status, data } = err.response;
      return rejectWithValue({ status, errorMessage: data });
    }
})

export const updateOnboardingSteps = createAsyncThunk<OnboardingSteps[], UpdateOnboardingStepsRequest>('updateOnboardingSteps', async({shop_id, ...request}: UpdateOnboardingStepsRequest, {rejectWithValue}) => {
	try {
		const { data } = await client.post(`${url}/${shop_id}`, { ...request })
		return data;
	}catch (err: any) {
      const { status, data } = err.response;
      return rejectWithValue({ status, errorMessage: data });
    }
})

const slice = createSlice({
	name: 'onboardingSlice',
	initialState,
	reducers: {
		resetOnboardingStatus: (state) => {
			state.status = 'idle';
			state.updateStatus = 'idle';
		  },
	},
	extraReducers: (builder) => {
		builder.addCase(getOnboardingSteps.pending, state => {
			state.status = 'loading';
		})
		.addCase(getOnboardingSteps.fulfilled, (state, action) => {
			state.status = 'successful';
			state.data = action.payload;
		})
		.addCase(getOnboardingSteps.rejected, (state, action) => {
			state.status = 'error';
        	state.errors = action.payload;
		})
		.addCase(updateOnboardingSteps.pending, state => {
			state.updateStatus = 'loading';
		})
		.addCase(updateOnboardingSteps.fulfilled, (state, action) => {
			state.updateStatus = 'successful';
			state.data = action.payload;
		})
		.addCase(updateOnboardingSteps.rejected, (state, action) => {
			state.updateStatus = 'error';
        	state.errors = action.payload;
		})
	}
})

export const { resetOnboardingStatus } = slice.actions;

export default slice.reducer;